import { ComponentProps } from "react";
import { PaperMaterialGroupSelectcion } from "share-components/group-selection/paper-material-group-selection/paper-material-group-selection";

type PaperMaterialGroupSelectionConnectedProps = ComponentProps<
  typeof PaperMaterialGroupSelectcion
>;

export const PaperMaterialGroupSelectionConnected = (
  props: PaperMaterialGroupSelectionConnectedProps,
) => {
  return <PaperMaterialGroupSelectcion {...props} />;
};
